/**
 * OAuth 2.0 / OpenID Connect Configuration
 * Provider: Keycloak (Precision AI)
 */

import { UserManagerSettings } from 'oidc-client-ts';

const KEYCLOAK_BASE_URL = 'https://auth.precision.ai/realms/precisionai';

// Determine redirect URI based on environment
const getRedirectUri = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000/callback';
  }
  // Production URL - update this when deployed
  return `${window.location.origin}/callback`;
};

const getSilentRedirectUri = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000/silent-renew.html';
  }
  return `${window.location.origin}/silent-renew.html`;
};

export const oidcConfig: UserManagerSettings = {
  // Keycloak endpoints
  authority: KEYCLOAK_BASE_URL,
  client_id: 'data-curation-webapp',
  redirect_uri: getRedirectUri(),
  silent_redirect_uri: getSilentRedirectUri(),
  post_logout_redirect_uri: window.location.origin,

  // OAuth flow settings
  response_type: 'code', // Authorization Code Flow
  scope: 'openid profile email',

  // PKCE for security (required for public clients)
  response_mode: 'query',

  // Token settings
  automaticSilentRenew: true, // Enable automatic token refresh before expiration
  silentRequestTimeoutInSeconds: 10, // Timeout for silent renew requests
  accessTokenExpiringNotificationTimeInSeconds: 60, // Start refresh 60s before expiry
  loadUserInfo: false, // Don't call userinfo endpoint - get claims from ID token instead
  filterProtocolClaims: false, // Keep all claims from ID token
  includeIdTokenInSilentRenew: true, // Include id_token in silent renew

  // Metadata (optional - will be auto-discovered from authority)
  metadata: {
    issuer: KEYCLOAK_BASE_URL,
    authorization_endpoint: `${KEYCLOAK_BASE_URL}/protocol/openid-connect/auth`,
    token_endpoint: `${KEYCLOAK_BASE_URL}/protocol/openid-connect/token`,
    userinfo_endpoint: `${KEYCLOAK_BASE_URL}/protocol/openid-connect/userinfo`,
    end_session_endpoint: `${KEYCLOAK_BASE_URL}/protocol/openid-connect/logout`,
    jwks_uri: `${KEYCLOAK_BASE_URL}/protocol/openid-connect/certs`,
  },
};

export default oidcConfig;
